module.exports = __webpack_public_path__ + "static/Blue Glitter Explosion HD 1-5e1c73269d6df27966c4291b48b0c77f.mp4";